import React from "react";
import PropTypes from "prop-types";
import "../../styles/RadioInput.scss";

const RadioInput = (props) => {
    const { name, handleChange, checked, id, fieldRegister, disabled,value,text } = props;

    return (
        <React.Fragment>
             <input                   
                    type="radio"
                    name={name}
                    id={id}
                    value={value}
                    onChange={handleChange}
                    checked={checked}
                    disabled={disabled}
                    data-testid={id}
                    {...fieldRegister}                    
                />
            <label htmlFor={id} className="ml-5">{text}</label>
            {/* {errorMessage && <ErrorMessage error={errorMessage} />} */}
        </React.Fragment>
    );
};

RadioInput.propTypes = {
    name: PropTypes.string,   
    id: PropTypes.string,
    errorMessage: PropTypes.string,
    handleChange: PropTypes.func,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,   
    value:PropTypes.string,
    text:PropTypes.string
}

export default RadioInput;